import { CToast, CToastBody, CToaster, CToastHeader } from '@coreui/react';
import React from 'react';
import { connect, DispatchProp } from 'react-redux';
import classNames from 'classnames';
import { RootState } from '../../store/state';
import { ToastInfo, ToastTypes } from '../models/toast';
import { RemoveToast } from '../../store/actions/toaster.action';

export const TOAST_TIMEOUT = 3000;

export interface ToasterProps extends DispatchProp {
    toasts: ToastInfo[],
    autohide?: boolean|number;
}

const Toaster = (props: ToasterProps) => {
    const { dispatch, toasts, autohide = TOAST_TIMEOUT } = props;

    const handleStateChange = (toast: ToastInfo) => state => {
        if (state === 'closing') {
            dispatch(new RemoveToast(toast.id))
        }
    };

    return (
        <CToaster position="top-right">
            { toasts.map(toast => {
                const classes = classNames({
                    'toast-success': toast.type === ToastTypes.Success,
                    'toast-danger': toast.type === ToastTypes.Error,
                });

                return (
                    <CToast
                      key={ toast.id }
                      show
                      onStateChange={ handleStateChange(toast) }
                      className={ classes }
                      autohide={ autohide }
                    >
                        <CToastHeader>
                            { toast.title }
                        </CToastHeader>
                        <CToastBody>
                            { toast.body }
                        </CToastBody>
                    </CToast>
                );
            }) }
        </CToaster>
    );
};

const mapStateToProps = (state: RootState) => ({
    toasts: state?.toasts?.toasts,
});

export default connect(mapStateToProps)(Toaster);
